export type TVideoRecord = {
  region: string;
  authorName: string;
  //videCoverImage: StaticImageData;
};

export const videoRecords: { [bvid: string]: TVideoRecord } = {
  BV1V3rVYMEqU: {
    region: '上海站',
    authorName: '蔡金龙，小红书关系数据库负责人',
  },
  BV1VurVYzEdD: {
    region: '上海站',
    authorName: '郑圣瑜，华安基金大数据开发工程师',
  },
  BV15urVYzE6s: {
    region: '上海站',
    authorName: '孟维克，爱奇艺 DBA',
  },
  BV15urVYzEpr: {
    region: '上海站',
    authorName: '郭灏，咪咕视讯数据库中间件技术专家',
  },
  BV15urVYzE2H: {
    region: '上海站',
    authorName: '杨赛峰，数禾科技资深 DBA',
  },
  BV15urVYzEVd: {
    region: '上海站',
    authorName: '姚春晖，TiDB 社区版主',
  },
  BV1bUoLYyEZZ: {
    region: '南京站',
    authorName: '白鳝 DBAIOPS 社区发起人',
  },
  BV18UoLYyEwF: {
    region: '南京站',
    authorName: '郭枫 南京证券 数据团队负责人',
  },
  BV18UoLYyEKW: {
    region: '南京站',
    authorName: '徐驰 恺恩泰（南京）科技有限公司 解决方案总监',
  },
  BV18UoLYyEgY: {
    region: '南京站',
    authorName: '刘杰 江苏广电 大数据开发工程师',
  },
  BV1yJoLYeEFz: {
    region: '南京站',
    authorName: '刘松 PingCAP 副总裁',
  },
  BV1QfjdzMEjg: {
    region: '重庆站',
    authorName: '谭清如 马上消费金融 技术专家',
  },
  BV13fjdzuEf3: {
    region: '重庆站',
    authorName: '刘攀 重庆富民银行 DBA',
  },
  BV1eXjdzGEB7: {
    region: '重庆站',
    authorName: '余长发 智慧之家科技 副总裁',
  },
  BV1XojdzzE29: {
    region: '重庆站',
    authorName: '雷宇 英科融合（重庆）科技 副总经理',
  },
  BV1eXjdzGEz5: {
    region: '重庆站',
    authorName: '赵伟 ZStack 解决方案总监',
  },
  BV1DFjozqE1f: {
    region: '重庆站',
    authorName: '王豪 杭州云猿生数据 解决方案架构师',
  },
  BV1hFjozqEwf: {
    region: '重庆站',
    authorName: '沈鑫 国家超级计算（无锡）中心、太初科技 行业总监',
  },
  BV1peKcz6EJS: {
    region: '沈阳站',
    authorName: '卢秀红 亿联银行科技管理部副总经理、运维中心负责人',
  },
  BV1VDKczfE1s: {
    region: '沈阳站',
    authorName: '向安杰 京东集团研发工程师',
  },
  BV1G9KczoEmG: {
    region: '沈阳站',
    authorName: '付昌昌 辽宁联通网络 IT 系统架构师',
  },
  BV16FKAzrERt: {
    region: '沈阳站',
    authorName: '穆佳良 新基集团信创产品部经理',
  },
  BV12CKFzyEfQ: {
    region: '沈阳站',
    authorName: '蓝功儒 TiDB 解决方案架构师',
  },
  BV1rvbazSEgC: {
    region: '厦门站',
    authorName: '赵丹｜美柚 DBA',
  },
  BV1rebaznEdP: {
    region: '厦门站',
    authorName: '杨镕恺｜厦门兆翔智能科技研发工程师',
  },
  BV17Z421M73B: {
    region: '武汉站',
    authorName: '韦万 | TiDB 研发工程师，曾经参与 TiFlash，目前负责 TiCDC 的研发工作',
  },
  BV184SqY9Edf: {
    region: '杭州站',
    authorName: '赵月顺 | 哔哩哔哩数据库负责人',
  },
  BV1h4SqY9EkA: {
    region: '杭州站',
    authorName: '邵健 | 杭州银行数据库专家',
  },
  BV1g4SqY9E2e: {
    region: '杭州站',
    authorName: '李家林 | 安能物流运维负责人',
  },
  BV134SqY9EN7: {
    region: '杭州站',
    authorName: '',
  },
  BV1g4SqY9Eto: {
    region: '杭州站',
    authorName: '宋日杰 | PingCAP 产品经理',
  },
  BV1yarfYnEiH: {
    region: '大连站',
    authorName: '严少安 | TiDB 社区版主',
  },
  BV1KbrfYWEqq: {
    region: '大连站',
    authorName: '李震 | Rakuten INPD 高级软件开发工程师',
  },
  BV18AkFYFEnG: {
    region: '大连站',
    authorName: '宋日杰 | TiDB 产品经理',
  },
  BV1N8rfYXE9m: {
    region: '大连站',
    authorName: '曹海峰 | 伊莱科技数据库专家',
  },
  BV118rfYQErw: {
    region: '大连站',
    authorName: '张纪宽 | 海信聚好看云平台开发部、大数据平台部部长',
  },
  BV1Es421M7YB: {
    region: '武汉站',
    authorName: '何傲 | 神州数码 TiDB 团队技术负责人',
  },
  BV1rf421Q7o3: {
    region: '武汉站',
    authorName: '谭品学 | 丰巢科技有限公司数据库负责人',
  },
  BV1Q6421Z73E: {
    region: '武汉站',
    authorName: '肖飞 | 嘉里大通物流架构团队负责人',
  },
  BV15T421S7ZM: {
    region: '北京站',
    authorName: '董宇 | TiDB Compute 团队负责人',
  },
  BV1Ws421w7Cx: {
    region: '北京站',
    authorName: '管元峥 |  360 商业化数据库负责人',
  },
  BV1us421A7DX: {
    region: '北京站',
    authorName: '魏建强 | 竞技世界 DBA',
  },
  BV1r7421f7o3: {
    region: '北京站',
    authorName: '姜皓楠 |  TiDB 内核产品经理负责人',
  },
  /**
   * 成都站
   * 1. 标题：MySQL 又不是不能用，为什么用 TiDB?
   *       冯光普 | 多点 DMALL 数据库团队负责人
   *       视频链接：https://www.bilibili.com/video/BV1pb421Y74c/
   *
   * 2. 标题：TiDB vs MySQL：消费金融公司在高并发、跨中心热备场景下的实践探索
   *      段勇 | 马上消费金融 DBA
   *      视频链接：https://www.bilibili.com/video/BV1dD421J7Zv/
   *
   * 3. 标题：出海 + 多云架构丨多点 TiDB 运维实战分享
   *      唐万民 | 多点 DMALL 国内数据库负责人
   *      视频链接：https://www.bilibili.com/video/BV1vF4m1w7cT/
   *
   * 4. 标题：从 0-1 应用实践：互联网行业数字化选品服务场景下 MySQL 到 TiDB 的演进之旅
   *      赵明中 | 大淘客科技 DBA、数据库架构师
   *      视频链接：https://www.bilibili.com/video/BV1Rb421Y7S5/
   *
   * 5. 标题：稳定性增强！TiDB v8.1.0 LTS 新功能揭秘，聊聊适用场景及未来计划
   *      宋日杰 | PingCAP 产品经理
   *      视频链接：https://www.bilibili.com/video/BV1Vp421Q78p/
   */
  BV1pb421Y74c: {
    region: '成都站',
    authorName: '冯光普 | 多点 DMALL 数据库团队负责人',
  },
  BV1dD421J7Zv: {
    region: '成都站',
    authorName: '段勇 | 马上消费金融 DBA',
  },
  BV1vF4m1w7cT: {
    region: '成都站',
    authorName: '唐万民 | 多点 DMALL 国内数据库负责人',
  },
  BV1Rb421Y7S5: {
    region: '成都站',
    authorName: '赵明中 | 大淘客科技 DBA、数据库架构师',
  },
  BV1Vp421Q78p: {
    region: '成都站',
    authorName: '宋日杰 | PingCAP 产品经理',
  },
  /**
   * 深圳站
   * 1. 标题：从多套 MySQL 到 1 套 TiDB - 骏伯网络综合运营管理平台应用实践
   *      唐帆 | 广州骏伯网络科技有限公司系统架构师
   *      视频链接：https://www.bilibili.com/video/BV1cZ421Y7UL/
   *
   * 2. 标题：零售业 ToC 系统的数据库选型
   *      崔文涛 | 云盛海宏架构师
   *      视频链接：https://www.bilibili.com/video/BV1Yj421Z7eG/
   *
   * 3. 标题：网易游戏规模化 TiDB SaaS 服务建设
   *      田维繁 | 网易游戏 SaaS 服务关系型数据库运维小组负责人
   *      视频链接：https://www.bilibili.com/video/BV1t6421c7k6/
   *
   * 4. 标题：SHOPLINE TiDB 4.0 到 6.5 升级之路
   *      车佳蔚 | Shopline 数据库/ TiDB 负责人
   *      视频链接：https://www.bilibili.com/video/BV1Ht421V7zp/
   *
   * 5. 标题：NewSQL 分布式数据库选型和实践
   *      苏程辉 | 趣丸科技数据库/中间件负责人
   *      视频链接：https://www.bilibili.com/video/BV1ei421d7ew/
   *
   * 6. 标题：TiDB 7.5 LTS 高性能处理方案
   *      汤博文 | PingCAP 售前顾问
   *      视频链接：https://www.bilibili.com/video/BV1L2421N7xb/
   *
   * 7. 标题：TiDB 资源管控特性解读及应用探索
   *      李文杰 | TiDB 社区版主，TiDB 华南地区组织者
   *      视频链接：https://www.bilibili.com/video/BV1kw4m1Z7st/
   */
  BV1cZ421Y7UL: {
    region: '深圳站',
    authorName: '唐帆 | 广州骏伯网络科技有限公司系统架构师',
  },
  BV1Yj421Z7eG: {
    region: '深圳站',
    authorName: '崔文涛 | 云盛海宏架构师',
  },
  BV1t6421c7k6: {
    region: '深圳站',
    authorName: '田维繁 | 网易游戏 SaaS 服务关系型数据库运维小组负责人',
  },
  BV1Ht421V7zp: {
    region: '深圳站',
    authorName: '车佳蔚 | Shopline 数据库/ TiDB 负责人',
  },
  BV1ei421d7ew: {
    region: '深圳站',
    authorName: '苏程辉 | 趣丸科技数据库/中间件负责人',
  },
  BV1L2421N7xb: {
    region: '深圳站',
    authorName: '汤博文 | PingCAP 售前顾问',
  },
  BV1kw4m1Z7st: {
    region: '深圳站',
    authorName: '李文杰 | TiDB 社区版主，TiDB 华南地区组织者',
  },
  BV1w5411i7L3: {
    region: '北京站',
    authorName: '戴涛 | PingCAP 中国业务解决方案技术部总经理',
  },
  BV1o5411v7Sf: {
    region: '北京站',
    authorName: '徐礼佳 | PingCAP 北美大客户架构师',
  },
  BV1NW4y1A7AG: {
    region: '北京站',
    authorName: '张烨 | TiDB 内核产品经理',
  },
  BV1ce411v7EW: {
    region: '北京站',
    authorName: '黄漫绅 | TiDB 社区运营',
  },
  BV1FT4y1n7fn: {
    region: '北京站',
    authorName: '代晓磊 | 知乎数据库负责人',
  },
  BV1ie411U7wQ: {
    region: '北京站',
    authorName: '刘强 | 作业帮数据库架构师，分布式数据库负责人',
  },
  BV1BC4y1K75s: {
    region: '上海站',
    authorName: '薛晓刚 | 欧冶云商首席数据库专家',
  },
  BV1Fe411z7L3: {
    region: '上海站',
    authorName: '蒋明 | 前淘宝 DBA',
  },
  BV1si4y1h7xF: {
    region: '上海站',
    authorName: '王军 | 5年+ PingCAPer',
  },
  BV1se411z73s: {
    region: '上海站',
    authorName: 'Eason 蒋皓楠 | TiDB 内核产品经理负责人',
  },
  BV1sV4y1W7dg: {
    region: '广州站',
    //title: '网易互娱在 TiDB SaaS 运维平台的建设',
    //description: '',
    //videCoverImage: cover1Image,
    authorName: '田维繁 | 网易互娱资深数据库工程师',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV1sV4y1W7dg',
  },
  BV1nG41147Ng: {
    region: '广州站',
    //title: 'TiDB 冷热存储分离方案',
    //description: '',
    //videCoverImage: cover2Image,
    authorName: '李文杰 | 网易游戏计费组 TiDB 负责人',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV1nG41147Ng',
  },
  BV1Ba41157Wp: {
    region: '广州站',
    //title: 'TiKV 架构及原理介绍',
    //description: '',
    //videCoverImage: cover3Image,
    authorName: '邓力铭 | PingCAP 高级开发工程师',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV1Ba41157Wp',
  },
  BV1hg411r7iv: {
    region: '广州站',
    //title: 'Demo Show-mini OSSInsight',
    //description: '',
    //videCoverImage: cover4Image,
    authorName: '陈霜 | TiDB 社区高级工程师',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV1hg411r7iv',
  },
  BV1vT41177V6: {
    region: '武汉站',
    //title: '实战 | 如何做好一次 TiDB POC 测试',
    //description: '',
    //videCoverImage: cover5Image,
    authorName: '何傲 | 神州数码  高级后端开发工程师',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV1vT41177V6',
  },
  BV1ja411M7LN: {
    region: '武汉站',
    //title: 'TiDB 开发操作的一些想法和展望',
    //description: '',
    //videCoverImage: cover6Image,
    authorName: '肖飞 | 嘉里大通物流 架构师',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV1ja411M7LN',
  },
  BV1hW4y1U7tH: {
    region: '济南站',
    //title: 'TiDB 介绍 & TiSpark 实践',
    //description: '',
    //videCoverImage: cover7Image,
    authorName: '张田 | 浪潮集团 架构师',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV1hW4y1U7tH',
  },
  BV14B4y1i76J: {
    region: '济南站',
    //title: 'TiSpark + Hudi + Kyuubi 混合数据湖方案',
    //description: '',
    //videCoverImage: cover8Image,
    authorName: '许新浩 | 万方数据',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV14B4y1i76J',
  },
  BV1ZT41137fC: {
    region: '济南站',
    //title: '运维视角下的 Linux 避坑指南',
    //description: '',
    //videCoverImage: cover9Image,
    authorName: '类延良 | PostgreSQL 14 数据库软件贡献者',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV1ZT41137fC',
  },
  BV1uZ4y1v7gg: {
    region: '济南站',
    //title: 'Greenplum 的 MPP 特性分享及选型思考',
    //description: '',
    //videCoverImage: cover10Image,
    authorName: '苑泽福 | TiDB 社区爱好者',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV1uZ4y1v7gg',
  },
  BV1e34y1p7gL: {
    region: '济南站',
    //title: '基于 Oracle DBSAT 的实践总结及思考',
    //description: '',
    //videCoverImage: cover11Image,
    authorName: '李兴帅 | 很熟悉 Oracle 的DBA',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV1e34y1p7gL',
  },
  BV1uW4y1r73R: {
    region: '天津站',
    //title: 'MySQL 和 TiDB CDC 原理对比',
    //description: '',
    //videCoverImage: cover12Image,
    authorName: '曹东瑜 | TiDB 天津地区组织者',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV1uW4y1r73R',
  },
  BV15W4y1S7YK: {
    region: '天津站',
    //title: 'MySQL MGR + 自研脚本实现高可用切换',
    //description: '',
    //videCoverImage: cover13Image,
    authorName: '李小锋 | 长城汽车开发工程师',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV15W4y1S7YK',
  },
  BV13N4y1u7uf: {
    region: '天津站',
    //title: '新型数仓 Databend 的存储层设计',
    //description: '',
    //videCoverImage: cover14Image,
    authorName: 'Xuanwo | 开源主义者',
    //moreLinkUrl: 'https://www.bilibili.com/video/BV13N4y1u7uf',
  },
};
